module.exports = __webpack_public_path__ + "img/horizontal_5_1_8004.91bcc772.png";